import { useTranslate } from '@va/localization';
import { Paragraph, paragraphSizes } from '@va/ui/design-system';
import { UrlStructureItems } from './UrlStructureItems';

export const UrlPatternStructure = () => {
  const translate = useTranslate();
  return (
    <div className='flex flex-col rounded-3xl max-w-700px p-3'>
      <Paragraph size={paragraphSizes.large} className='text-center font-550'>
        {translate('urlPattern.structure.title')}
      </Paragraph>
      <Paragraph className='text-center font-525 mt-1.5 mb-30px'>{translate('urlPattern.structure.info')}</Paragraph>
      <UrlStructureItems />
    </div>
  );
};
